import vidbg from '../../../../assets/scripts/autoload/vidbg.js';
$(function () {
  if ($('.Hero--home').length) {
    var instance = new vidbg('.Hero--home', {
      mp4: 'app/themes/windpoint/hero_vd.mp4',
      // URL or relative path to MP4 video
      webm: 'app/themes/windpoint/hero_vd.webm',
      // URL or relative path to webm video
      poster: 'app/themes/windpoint/hero_vd_fallback.jpeg',
      // URL or relative path to fallback image
      overlay: true,
      // Boolean to display the overlay or not
      overlayColor: '#000',
      // The overlay color as a HEX
      overlayAlpha: 0.0 // The overlay alpha. Think of this as the last integer in RGBA()

    }, {
      // Attributes
      muted: true
    });
  } // $(".Hero-autoScroll").click(function() {
  //     var section = $(this).closest("section");
  //     var next = section.next("section");
  //     if (next) {
  //         var offsetTop = next.offset().top - $("header").outerHeight();
  //         $("html, body").animate({
  //             scrollTop: offsetTop
  //         });
  //     }
  // });
  // $(".Hero-feed--slider").flickity({
  //     contain: true,
  //     imagesLoaded: true,
  //     pageDots: false
  // });


  $('.HeroSlider-container').flickity({
    cellSelector: '.HeroSlider-slide',
    autoPlay: 4500,
    imagesLoaded: true,
    pageDots: false,
    prevNextButtons: false,
    groupCells: 1,
    wrapAround: true,
    setGallerySize: false,
    friction: 0.7,
    cellAlign: 'center'
  });
});